import styled, { css } from "styled-components";
import { Popover } from "@diana-ui/popover";
export var StyledPopover = /*#__PURE__*/ styled(Popover).withConfig({
  displayName: "Dropdownstyle__StyledPopover"
})(() => css(["max-width:100%;min-width:220px;"]));
export var StyledHeader = /*#__PURE__*/ styled.div.withConfig({
  displayName: "Dropdownstyle__StyledHeader"
})(() => css(["padding:10px 0px;"]));
export var StyledText = /*#__PURE__*/ styled.div.withConfig({
  displayName: "Dropdownstyle__StyledText"
})(() => css(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]));
export var Wrapper = /*#__PURE__*/ styled.div.withConfig({
  displayName: "Dropdownstyle__Wrapper"
})(() => css(["display:flex;align-items:flex-start;"]));
export var List = /*#__PURE__*/ styled.ul.withConfig({
  displayName: "Dropdownstyle__List"
})(() =>
  css([
    "list-style:none;margin-bottom:0;margin-top:0;max-height:300px;overflow-y:auto;padding-left:0px;width:100%;"
  ])
);
export var Item = /*#__PURE__*/ styled.div.withConfig({
  displayName: "Dropdownstyle__Item"
})(() => css(["cursor:pointer;&.disabled{cursor:default;pointer-events:none;}"]));
export var ItemText = /*#__PURE__*/ styled.span.withConfig({
  displayName: "Dropdownstyle__ItemText"
})(() => css(["display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]));
export var StyledLabel = /*#__PURE__*/ styled.label.withConfig({
  displayName: "Dropdownstyle__StyledLabel"
})(() => css(["padding:10px 0px;"]));
